import { createAction } from 'redux-actions';

export const clearGuestFiles = createAction('CLEAR_GUEST_FILES');

export const guestFilesOnChangePage = createAction(
  'GUEST_FILES_ON_CHANGE_PAGE'
);

export const guestFilesOnChangeOrder = createAction(
  'GUEST_FILES_ON_CHANGE_ORDER'
);
